import { render } from "./Configuration.vue?vue&type=template&id=c9902390&scoped=true"
import script from "./Configuration.vue?vue&type=script&lang=js"
export * from "./Configuration.vue?vue&type=script&lang=js"

import "./Configuration.vue?vue&type=style&index=0&id=c9902390&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9902390"]])

export default __exports__